import { Routes, Route, Navigate } from 'react-router-dom';

import { CountryProvider } from './contexts/CountryContext.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Layout from './components/Layout.jsx';
import GAListener from './components/GAListener.jsx';

import Home from './pages/Home.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Create from './pages/Create.jsx';
import Video from './pages/Video.jsx';
import Pricing from './pages/Pricing.jsx';
import Account from './pages/Account.jsx';
import Admin from './pages/Admin.jsx';
import Privacy from './pages/Privacy.jsx';
import Terms from './pages/Terms.jsx';

function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center text-gray-500">
      404
    </div>
  );
}

import { SIGNUP_CLOSED, PAID_CLOSED } from './utils/siteMode.js';

export default function App() {
  return (
    <CountryProvider>
      <AuthProvider>
        <GAListener />
        <Routes>
          {/* Auth 페이지는 Navbar 없이 */}
          <Route path="/login" element={<Login />} />
          {/* 신규 가입 종료 (2026-08-28, siteMode.js 참조).
              /register 로 오는 링크가 앱 곳곳(PlanCard·Video·ProtectedRoute)에 남아 있는데,
              라우트에서 한 번에 막으면 그것들이 전부 무해해진다. */}
          <Route path="/register" element={SIGNUP_CLOSED ? <Navigate to="/login" replace /> : <Register />} />

          {/* 일반 페이지는 Layout 안 */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            {/* 유료 결제 종료 (2026-08-28, siteMode.js 참조). */}
            <Route path="/pricing" element={PAID_CLOSED ? <Navigate to="/" replace /> : <Pricing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create"
              element={
                <ProtectedRoute>
                  <Create />
                </ProtectedRoute>
              }
            />
            <Route path="/video/:id" element={<Video />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </CountryProvider>
  );
}
